import type { Theme } from '../../types/theme';

export const raycastTheme: Theme = {
  id: 'raycast',
  name: 'Raycast',
  description: 'Near-black canvas with white CTA pill, Inter ss03 typography',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/raycast/DESIGN.md',
  visualKeywords: ['dark', 'command palette', 'ss03 typography', 'white CTA', 'developer'],
  colors: {
    background: '#07080a',
    surface: '#0d0d0d',
    surfaceElevated: '#171717',
    textPrimary: '#f4f4f6',
    textSecondary: '#cdcdcd',
    textMuted: '#cdcdcd',
    border: '#242728',
    borderSubtle: '#2e3132',
    primary: '#ffffff',
    primaryHover: '#ebebeb',
    primaryActive: '#e1e1e1',
    accent: '#ffffff',
    onPrimary: '#000000',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'high',
    tone: 'efficient',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
